import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {StudijnyPlan} from '../model/StudijnyPlan';
import {StudijnyPlanItem} from '../model/StudijnyPlanItem';

@Component({
    selector: 'app-vyber-jazyka',
    templateUrl: './vyber-jazyka.component.html',
    styleUrls: ['./vyber-jazyka.component.css'],
    standalone: false
})
export class VyberJazykaComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<VyberJazykaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {predmet: StudijnyPlanItem}
  ) { }

  ngOnInit(): void {
  }

  onSelect(jazyk: string) {
    this.dialogRef.close(jazyk);
  }
}
